/* global axios */
import ApiClient from './ApiClient';

class PatientsAPI extends ApiClient {
  constructor() {
    super('patients', { accountScoped: true });
  }

  get(page, sortAttr = 'name', clientId = null) {
    let requestURL = `${this.url}?page=${page}&sort=${sortAttr}`;
    if (clientId) {
      requestURL += `&client_id=${clientId}`;
    }
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  search(search = '', page = 1, sortAttr = 'name', clientId = null) {
    let requestURL = `${this.url}/search?q=${search}&page=${page}&sort=${sortAttr}`;
    if (clientId) {
      requestURL += `&client_id=${clientId}`;
    }
    return axios.get(requestURL);
  }

  filter(page = 1, sortAttr = 'name', queryPayload, clientId = null) {
    let requestURL = `${this.url}/filter?page=${page}&sort=${sortAttr}`;
    if (clientId) {
      requestURL += `&client_id=${clientId}`;
    }
    return axios.post(requestURL, queryPayload);
  }
}

export default new PatientsAPI();

